import { Controller } from "stimulus";

// The stream form's "Who can watch" group. Each mode that uses a plan picker has its own panel; only the
// chosen mode's panel is shown and enabled (auto-save skips disabled controls and a real submit never sends
// them). Changing mode puts the newly shown picker back to its "all" option: the server clears the event's
// plans on that same save, so the picker must not reappear later showing plans it no longer has.
export default class AudienceController extends Controller {
  static targets = ["mode", "panel"];

  connect() {
    this.savedMode = this.selectedMode;
    this.apply();
  }

  select() {
    this.apply();
    this.resetPicker(this.activePanel);
  }

  // Leaving tickets mode can archive the stream's ticket on that save, and entering it shows the ticket card, so
  // reload to show the card as it is now. Restoring an archived ticket is an explicit action, never a mode change.
  saved() {
    const previous = this.savedMode;
    this.savedMode = this.selectedMode;
    if (previous !== "tickets" && this.savedMode !== "tickets") return;

    window.Turbo.visit(window.location.href, { action: "replace" });
  }

  apply() {
    const mode = this.selectedMode;
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.mode === mode;
      panel.hidden = !active;
      panel.querySelectorAll("input, select, textarea").forEach((control) => {
        control.disabled = !active;
      });
      // Tom Select keeps its own disabled state, read from the input when it initialises.
      const tom = this.planInput(panel)?.tomselect;
      if (tom) {
        if (active) tom.enable();
        else tom.disable();
      }
    });
  }

  // Back to "all" without an auto-save of its own: clear(true) is silent (no input/change on the
  // plan field), and the radio's change only re-renders TargetingComponent's label - its own
  // follow-up clear() returns early once nothing is selected.
  resetPicker(panel) {
    if (!panel) return;

    const input = this.planInput(panel);
    if (input) {
      if (input.tomselect) input.tomselect.clear(true);
      input.value = "";
    }

    const all = panel.querySelector("input[type='radio'][value='all']");
    if (all) {
      all.checked = true;
      all.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  get selectedMode() {
    return this.modeTargets.find((radio) => radio.checked)?.value || "subscribers";
  }

  get activePanel() {
    return this.panelTargets.find((panel) => panel.dataset.mode === this.selectedMode);
  }

  planInput(panel) {
    return panel.querySelector("[data-targeting-component-target='planSelect']");
  }
}
